import { useState } from "react";
import { Link } from "react-router-dom";

function gerarSlug(nome) {
  return nome
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-");
}

function ProductCard({ produto }) {
  const [imgErro, setImgErro] = useState(false);

  const mensagem = `Olá! Tenho interesse no produto: ${produto.nome}`;
  const whatsapp = `https://wa.me/554999140597?text=${encodeURIComponent(mensagem)}`;

  return (
    <div className="product-card">

      {/* IMAGEM CLICÁVEL */}
      <Link to={`/produto/${gerarSlug(produto.nome)}`} className="product-link">
        <div className="product-image-container">
          {!imgErro ? (
            <img
              src={produto.imagem}
              alt={produto.nome}
              className="product-image"
              loading="lazy"
              onError={() => setImgErro(true)}
            />
          ) : (
            <div className="product-image-placeholder">
              Imagem indisponível
            </div>
          )}
        </div>
      </Link>

      {/* TÍTULO (SEM LINK) */}
      <h3 className="product-title">{produto.nome}</h3>

      <p className="product-description">{produto.descricao}</p>

      {/* BOTÃO WHATSAPP */}
      <a
        href={whatsapp}
        target="_blank"
        rel="noreferrer"
        className="product-button"
      >
        Solicitar orçamento
      </a>

    </div>
  );
}

export default ProductCard;